import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type UpdateChannelMutationVariables = Types.Exact<{
  data: Types.UpdateChannelInput;
}>;


export type UpdateChannelMutation = { updateChannel?: { success?: boolean | null } | null };


export const UpdateChannelDocument = /*#__PURE__*/ gql`
    mutation UpdateChannel($data: UpdateChannelInput!) {
  updateChannel(data: $data) {
    success
  }
}
    `;

export function useUpdateChannelMutation() {
  return Urql.useMutation<UpdateChannelMutation, UpdateChannelMutationVariables>(UpdateChannelDocument);
};